module.exports = __webpack_public_path__ + "img/dried-chillies.98556363.jpg";